<template>
  <div class="sn-page sn-f-col-b-c schedule" :style="pattern">
    <div class="sn-f-s-0 sn-f-c-c schedule-header">
      <img class="logo" :src="ALI_CLOUD_DOMAIN_STATIC + '/hos/ui/images/pc/schedule/' + $sn.utils.getHospitalId() + '.png'">
      <img class="icon" :src="ALI_CLOUD_DOMAIN_STATIC + '/hos/ui/images/pc/schedule/header1.png'">
      <div class="title">{{ current.title || '' }}出诊信息表</div>
      <img class="icon" :src="ALI_CLOUD_DOMAIN_STATIC + '/hos/ui/images/pc/schedule/header2.png'">
    </div>
    <template v-if="current.schedule">
      <div class="sn-f-s-0 schedule-thead">
        <div class="sn-table">
          <table>
            <colgroup>
              <col style="width: 200px;">
              <col style="width: 100px;">
              <col :key="i" v-for="(date, i) in current.schedule.dateList">
            </colgroup>
            <thead>
              <tr>
                <th class="name">科室</th>
                <th class="noon">时段</th>
                <th :key="i" v-for="(date, i) in current.schedule.dateList">
                  <div>{{ $sn.format.date(new Date(date), 'MM月dd日') }}</div>
                  <div>周{{ $sn.format.day(date) }}</div>
                </th>
              </tr>
            </thead>
          </table>
        </div>
      </div>
      <div class="sn-f-1 schedule-tbody">
        <div class="sn-table" ref="slide">
          <table>
            <colgroup>
              <col style="width: 200px;">
              <col style="width: 100px;">
              <col :key="i" v-for="(date, i) in current.schedule.dateList">
            </colgroup>
            <tbody>
              <template v-for="item in current.schedule.scheduleList">
                <template>
                  <tr :key="item.id">
                    <td class="schedule-depart" :colspan="showScheduleDay + 2">
                      <img class="icon" :src="ALI_CLOUD_DOMAIN_STATIC + '/hos/ui/images/pc/schedule/depart1.png'">
                      <div class="title">{{ item.name }}</div>
                      <img class="icon" :src="ALI_CLOUD_DOMAIN_STATIC + '/hos/ui/images/pc/schedule/depart2.png'">
                    </td>
                  </tr>
                </template>
                <template v-for="(element, d2) in item.children">
                  <template v-if="element.children.length > 0">
                    <tr :key="item.id + element.id">
                      <td class="schedule-depart" :colspan="showScheduleDay + 2">
                        <img class="icon" :src="ALI_CLOUD_DOMAIN_STATIC + '/hos/ui/images/pc/schedule/depart1.png'">
                        <div class="title">{{ element.name }}</div>
                        <img class="icon" :src="ALI_CLOUD_DOMAIN_STATIC + '/hos/ui/images/pc/schedule/depart2.png'">
                      </td>
                    </tr>
                    <template v-for="(atomic, d3) in element.children">
                      <template v-if="atomic.children.length === 0">
                        <tr :style="{'background-color': d3 % 2 === 1 ? pattern['--schedule4'] : pattern['--schedule3']}"
                        :key="item.id + element.id + atomic.id + noon" v-for="(noon, i) in current.schedule.noonList">
                          <td class="name" v-if="i === 0" :rowspan="current.schedule.noonList.length">{{ atomic.name }}</td>
                          <td class="noon" :class="{'sn-bln': i !== 0}">{{ periodInfo[noon].itemName }}</td>
                          <td :key="j" v-for="(date, j) in current.schedule.dateList">
                            <template v-if="!$sn.validate.empty($sn.format.getQuality(atomic.noonMap, noon + '.' + date))">
                              <div class="sn-f-b-c sn-f-wrap">
                                <div class="schedule-doctor" :key="k" v-for="(schedule, k) in $sn.format.getQuality(atomic.noonMap, noon + '.' + date)">
                                  <template v-if="schedule.isStop === '1'">[停诊]</template>{{ schedule.doctorName }}
                                </div>
                              </div>
                            </template>
                            <template v-else>——</template>
                          </td>
                        </tr>
                      </template>
                    </template>
                  </template>
                  <template v-else>
                    <tr :style="{'background-color': d2 % 2 === 1 ? pattern['--schedule4'] : pattern['--schedule3']}"
                    :key="item.id + element.id + noon" v-for="(noon, i) in current.schedule.noonList">
                      <td class="name" v-if="i === 0" :rowspan="current.schedule.noonList.length">{{ element.name }}</td>
                      <td class="noon" :class="{'sn-bln': i !== 0}">{{ periodInfo[noon].itemName }}</td>
                      <td :key="j" v-for="(date, j) in current.schedule.dateList">
                        <template v-if="!$sn.validate.empty($sn.format.getQuality(element.noonMap, noon + '.' + date))">
                          <div class="sn-f-b-c sn-f-wrap">
                            <div class="schedule-doctor" :key="k" v-for="(schedule, k) in $sn.format.getQuality(element.noonMap, noon + '.' + date)">
                              <template v-if="schedule.isStop === '1'">[停诊]</template>{{ schedule.doctorName }}
                            </div>
                          </div>
                        </template>
                        <template v-else>——</template>
                      </td>
                    </tr>
                  </template>
                </template>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </template>
  </div>
</template>
<script type="text/javascript">
import { businessConfig } from '@/common/utils/function-config.js';
import self from '@/common/utils/global-config';
import Swagger from '@/common/utils/swagger.js';
import HomepageMixin from '@/common/mixin/homepage-mixin';
import AppointmentMixin from '@/pages/appointment/appointment-mixin';

export default {
  mixins: [HomepageMixin, AppointmentMixin],
  data() {
    return {
      ALI_CLOUD_DOMAIN_STATIC: self.$sn.constants.ALI_CLOUD_DOMAIN_STATIC,
      pageParams: {},
      enter: self.$sn.utils.getCurrentTime(),
      refreshInterval: null,
      entireInfo: [],
      current: {},
      slideInterval: null,
      showScheduleDay: self.$sn.getConfig('showScheduleDay')
    };
  },
  computed: {
    pattern() {
      const ordinary = {
        '--schedule1': '#1a47b7', // 页面背景
        '--schedule2': '#abd5ff', // 科室行背景
        '--schedule3': '#253669', // 表头及奇数行背景
        '--schedule4': '#1947b7', // 偶数行背景
        '--schedule5': '#243668' // 科室名称
      };
      const compare = {
        // 山东大学齐鲁医院
        [this.perpetual.HOSPITAL_ID_SDQL]: {
          '--schedule1': '#00746b', // 页面背景
          '--schedule2': '#befafa', // 科室行背景
          '--schedule3': '#00746b', // 表头及奇数行背景
          '--schedule4': '#15985f', // 偶数行背景
          '--schedule5': '#006971' // 科室名称
        }
      };
      return this.$sn.format.merge(ordinary, compare[this.$sn.utils.getHospitalId()]);
    }
  },
  created: async function() {
    document.title = this.$sn.utils.getHospitalTitle();
    this.$route.meta.title = this.$sn.utils.getHospitalTitle();
    this.pageParams = this.$route.query;
    if (!this.pageParams.area) this.pageParams.area = this.$sn.utils.getHospitalAreaId();
    this.$sn.assembly.loading(true);
    await this.appointment_mixin_period();
    this.$sn.assembly.loading(false);
    this.getEntireInfo();
    this.refreshInterval = setInterval(() => {
      this.getEntireInfo();
    }, 1 * 60 * 60 * 1000);
  },
  methods: {
    getEntireInfo() {
      const get = (type) => {
        let start = '';
        let end = '';
        if (this.$sn.getConfig('isShowTodaySchedule')) {
          if (this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'HHmmss') < this.$sn.getConfig('scheduleReleaseTime')) {
            start = this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd');
          }
          else {
            start = this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd', 1, 'day');
          }
        }
        else {
          start = this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd', 1, 'day');
        }
        end = this.$sn.format.date(new Date(start), 'yyyy-MM-dd', this.showScheduleDay - 1, 'day');
        return this.$sn.utils.ordinaryRequest({
          url: Swagger.pcEntireScheduleInfoByCondition,
          query: {
            hosArea: this.pageParams.area,
            hosId: this.$sn.utils.getHospitalId(),
            start: start,
            end: end,
            businessType: type,
            empty: false
          }
        }).then(result => {
          if (result && result.code === 0 && result.data) {
            const serial = this.entireInfo.findIndex(el => el.type === type);
            this.$set(this.entireInfo[serial], 'schedule', result.data);
          }
        });
      };
      const scoller = () => {
        if (this.slideInterval) {
          clearInterval(this.slideInterval);
        }
        this.$nextTick(() => {
          const slide = this.$refs.slide;
          const step = 1;
          const delay = 50;
          this.slideInterval = setInterval(() => {
            const {
              scrollHeight,
              clientHeight,
              scrollTop
            } = slide;
            const scroll = scrollHeight - clientHeight;
            const target = scrollTop + step;
            slide.scrollTop = target;
            if (scroll < target) {
              if (this.entireInfo.length > 1) {
                const serial = this.entireInfo.findIndex(el => el.type === this.current.type);
                if (serial < this.entireInfo.length - 1) {
                  this.current = this.entireInfo[serial + 1];
                }
                else this.current = this.entireInfo[0];
              }
              slide.scrollTop = 0;
            }
          }, delay);
        });
      };
      this.entireInfo = [];
      if (this.slideInterval) {
        clearInterval(this.slideInterval);
      }
      const business = businessConfig();
      this.$sn.getConfig('pcScheduleFunctionType').forEach(el => {
        const match = business.find(result => result.type === el);
        if (!this.$sn.validate.empty(match)) {
          this.entireInfo.push(match);
        }
      });
      if (this.entireInfo.length > 0) {
        this.$sn.assembly.loading(true);
        const request = {};
        this.entireInfo.forEach((el, i) => {
          this.$set(request, 'p' + i.toString(), get(el.type));
        });
        Promise.all(Object.values(request)).then(() => {
          this.$sn.assembly.loading(false);
          this.entireInfo = this.entireInfo.filter(result => !this.$sn.validate.empty(result.schedule));
          if (this.entireInfo.length > 0) {
            this.current = this.entireInfo[0];
            scoller();
          }
        });
      }
    }
  },
  beforeDestroy: function() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
    if (this.slideInterval) {
      clearInterval(this.slideInterval);
    }
  }
};
</script>
<style lang="scss" scoped>
$schedule1: var(--schedule1); // 页面背景
$schedule2: var(--schedule2); // 科室行背景
$schedule3: var(--schedule3); // 表头及奇数行背景
$schedule4: var(--schedule4); // 偶数行背景
$schedule5: var(--schedule5); // 科室名称

.schedule {
  background-color: $schedule1;
  padding: 20px 20px 40px;

  &-header {
    overflow: hidden;
    width: 100%;
    margin-bottom: 20px;
    position: relative;

    .logo {
      width: auto;
      height: 80%;
      position: absolute;
      bottom: 0;
      left: 0;
    }

    .title {
      font-size: 42px;
      font-weight: bold;
      color: $white;
      padding: 0 20px;
    }

    .icon {
      width: 30px;
      height: auto;
    }
  }

  &-thead,
  &-tbody {
    overflow: hidden;
    width: 100%;
    border: 2px solid $border1;

    .sn-table {
      table {
        table-layout: fixed;

        thead {
          background-color: $schedule3;

          th {
            font-weight: bold;
            border-top: none;
            border-right: 2px solid $border1;
            border-bottom: none;
            border-left: none;
            border-radius: 0;

            &:last-child {
              border-right: none;
            }
          }
        }

        tbody {
          td {
            border-top: none;
            border-right: 2px solid $border1;
            border-bottom: 2px solid $border1;
            border-left: none;

            &:last-child {
              border-right: none;
            }
          }
        }

        th,
        td {
          @include fs(20);

          height: auto;
          min-height: 30px;
          color: $white;
          padding: 10px;
        }

        .schedule-depart {
          @include fs(28);

          background-color: $schedule2;
          font-weight: bold;
          color: $schedule5;

          div,
          img {
            display: inline-block;

            &.title {
              padding: 0 20px;
            }

            &.icon {
              vertical-align: middle;
              width: 20px;
              height: auto;
            }
          }
        }

        .schedule-doctor {
          min-width: 48%;
          max-width: 96%;

          &:nth-child(2n+1) {
            margin-right: 2%;
          }
        }
      }
    }
  }

  &-tbody {
    border-top: none;
  }
}
</style>
